import { useQuery } from '@tanstack/react-query';
import type { CustomCategoryDetail } from '../types';

/**
 * カスタムカテゴリの詳細を取得するフック
 */
export default function useFetchCustomCategory(categoryId: number | null) {
  return useQuery({
    queryKey: ['custom_category', categoryId],
    queryFn: async () => {
      if (!categoryId) {
        return null;
      }

      const response = await fetch(`/agent/api/custom_categories/${categoryId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('カテゴリの取得に失敗しました');
      }

      const data: CustomCategoryDetail = await response.json();
      return data;
    },
    enabled: !!categoryId,
  });
}
